import { Tab as MTab, Tabs } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const TabsMenu = styled(Tabs) `
  .MuiTabs-flexContainer {
    border: 5px solid ${theme.palette.grey[300]};
    border-radius: 4px;
    width: fit-content;
    border-left: 0;
    border-right: 0;
  }
  .MuiTabs-indicator {
    ${({ firsttab, lasttab }) => `border-radius: ${firsttab === 'true'
    ? '0 0 0 4px'
    : lasttab === 'true'
        ? '0 0 4px 0'
        : '0 0 0 0'}`};
  }
`;
export const Tab = styled(MTab) `
  && {
    min-width: 155px;
  }
  &&.MuiTab-root.Mui-selected {
    background-color: #f0f0f0;
  }
  &&:first-of-type {
    border-left: 5px solid ${theme.palette.grey[300]};
  }
  &&:last-of-type {
    border-right: 5px solid ${theme.palette.grey[300]};
  }
`;
